<template>
  <div>
    <b-modal
      id="addtask-modal"
      style="justify-content: space-around"
      hide-footer
      :title="title_modal"
    >
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form>
        <div>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="عنوان: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Input.title"
                  placeholder="عنوان"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="تاریخ"
                label-for="input-2"
              >
                <date-picker required v-model="Input.due_date"></date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="ساعت: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Input.due_time"
                  placeholder="00:00"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="Type-gr" label="نوع پیگیری:" label-for="Type">
                <MDDropdown
                  v-bind:group="108"
                  v-model="Input.mdid108_type"
                ></MDDropdown>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="Type-gr" label="الویت انجام:" label-for="Type">
                <MDDropdown
                  v-bind:group="109"
                  v-model="Input.mdid109_type"
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="is_fav-gr" label="وضعیت:" label-for="is_done">
                <b-form-select
                  v-model="Input.is_done"
                  :options="is_donis"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group
            id="input-group-5"
            label="توضیحات: "
            label-for="input-5"
          >
            <b-form-textarea
              required
              id="input-5"
              v-model="Input.description"
              placeholder="توضیحات"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>

        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddTaskModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button style="width: 100%" variant="primary" @click="addTask"
              >ذخیره</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../../helpers/persianDate";
import MDDropdown from "../../../components/MDDropdown";
export default {
  name: "AddTask",
  components: {
    persianDate,
    MDDropdown,
  },
  props: ["afterdone", "customer_id", "task_id" , "parent_id"],
  data: function () {
    return {
      Input: {
        id: 0,
        title: null,
        mdid108_type: "",
        mdid109_type: "",
        due_date: "",
        due_time: "",
        is_done: null,
        description: "",
        customer_id: 0,
        parent_id: 0,
        event_id: 0,
      },
      title_modal: "پیگیری جدید",
      is_donis: [
        {
          value: 0,
          text: "انجام نشده",
        },
        {
          value: 1,
          text: "انجام شده",
        },
      ],
      errors: [],
    };
  },
  
  watch: {
    task_id: function (newVal, oldVal) {
      this.EditTask();
    },
  },
  methods: {
    hideAddTaskModal: function () {
      this.$bvModal.hide("addtask-modal");
    },
    addTask(evt) {
      this.errors = [];

      if (this.task_id != null) {
        this.Input.id = this.task_id;
      }
      if (this.customer_id != null) {
        this.Input.customer_id = this.customer_id;
      }
      if (this.parent_id != null) {
        this.Input.parent_id = this.parent_id;
        this.Input.is_done = 1;
      }
      httpHelper.postData("crmtasks", this.Input).then((response) => {
        if (response.success) {
          this.Input.description = "";
          this.Input.title = "";
          this.Input.due_date = null;
          this.Input.due_time = null;
          this.Input.mdid108_type = null;
          this.Input.mdid109_type = null;
          this.Input.is_done = null;

          this.errors = [];
          this.afterdone();
          this.hideAddTaskModal();
        } else {
          for (var key in response.error) {
            response.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
    },
    EditTask: function () {
      if (this.task_id != null) {
        this.title_modal = "ویرایش پیگیری";
        httpHelper.getData("crmtasks?id=" + this.task_id).then((res) => {
          if (res.success && res.result !== null) {
            this.Input = res.result;
            this.Input.due_time = persianDate.getTimeWithOutSecend(
              this.Input.due_time
            );
          }
        });
      } else {
        this.title_modal = "پیگیری جدید";
        this.Input.description = "";
        this.Input.title = "";
        this.Input.due_date = null;
        this.Input.due_time = null;
        this.Input.mdid108_type = null;
        this.Input.mdid109_type = null;
        this.Input.is_done = null;

        this.errors = [];
      }
    },
  },
};
</script>
